{
  "header": {
    "login": "Login",
    "account": "Account",
    "logout": "Logout",
    "profile": "Profile",
    "edit_profile": "Edit Profile",
    "quick_search": "Search...",
    "search_for": "Search Environet for",
    "current_org": "Current Organization",
    "collapse_menu": "Collapse Menu",
    "sign_out": "Sign Out",
    "support_ticket": "Support Ticket",
    "design_access_context": "Design Access Context",
    "select_org": "Select Organization...",
    "select_role": "Select Role...",
    "notifications": "Notifications",
    "unread_messages": "You have %{count} unread messages",
    "user_invitations": "User Invitations",
    "access_context": "Access Context"
  }
}
